<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>抢购助手</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <router-link :to="{path:'/tools/product/save'}">
          <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">添加</el-button>
        </router-link>
      </div>
      <div class="content">
        <el-table border :data="product_list">
          <el-table-column prop="name" label="活动名" align="center"></el-table-column>
          <el-table-column prop="type" label="平台" align="center"></el-table-column>
          <el-table-column prop="abbr_name" label="商品简称" align="center"></el-table-column>
          <el-table-column prop="full_name" label="商品全称" align="center"></el-table-column>
          <el-table-column prop="price" label="商品价格" align="center"></el-table-column>
          <el-table-column label="当天预约" align="center">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              开始时间: {{ scope.row.reserve_start }} <br>
              结束时间: {{ scope.row.reserve_end }}
            </template>
          </el-table-column>
          <el-table-column prop="activity_time" label="抢购时间" align="center"></el-table-column>
          <el-table-column prop="duration_time" label="持续时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <router-link :to="{ path : '/tools/product/save', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>

              <el-button
                v-if="scope.row.is_del == 0"
                class="success"
                type="text"
                @click="deleteProduct(scope.row.id)"
                icon="el-icon-setting"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 15,
      product_list: []
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getProducts();
    },
    deleteProduct(id) {
      let _id = id;
      this.$confirm("是否删除该条抢购商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          url: "/tools/product/delete",
          data:{
            id: _id,
          },
          type:"POST",
        }).then(res => {
          loading.close()
          this.$util.msg(res.msg, "success");
          setTimeout(() => {
            this.getProducts();
          }, 1200);
        });
      })
      .catch(() => {});
    },
    getProducts() {
      this.$ajax({
        url: "/tools/product/index",
        data:{
          page: this.page,
          limit: this.pageSize
        }
      }).then(data => {
        this.product_list = data.data.data;
        this.total = data.data.total;
      });
    },
  },
  mounted() {
    this.getProducts();
  },
};
</script>